module.exports = __webpack_public_path__ + "img/icon-calendar.f78cd96c.svg";